import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=7e1a0713"
import script from "./DeleteButton.vue?vue&type=script&lang=js"
export * from "./DeleteButton.vue?vue&type=script&lang=js"
import style0 from "./DeleteButton.vue?vue&type=style&index=0&id=7e1a0713&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports